import { AnimationBaseController, IAnimationControllerConfiguration, Inject, SoundType } from "@denishussar/html5-game-engine";
import { SoundConstants, SoundLevels } from "../../Constants/SoundConstants";


export enum loaderButtons {
    participate,
    dismiss
}
export enum loaderButtonState {
    released,
    hover,
    press
}

export interface ILoaderButtonControllerOptions {
    onClick: () => void;
}

export class LoaderButtonController extends AnimationBaseController {
    public $model;
    private _width: number;
    private _height: number;
    private onClick;
    public constructor(
        @Inject private _options: ILoaderButtonControllerOptions,
    ) {
        super('LoaderButtonController');
        this.onClick = _options.onClick;
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return {
            sounds: [
                {
                    id: SoundConstants.BUTTON_CLICK,
                    type: SoundType.SFX
                }
            ],
            onPointerDown: () => {
                this.playState(loaderButtonState.press);
                this.soundManager.playSound(SoundConstants.BUTTON_CLICK, 0, SoundLevels.UI_ACTION);
            },
            onPointerUp: () => {
                this.onClick();
                this.playState(loaderButtonState.released);
            },
            onPointerOver: () => {
                this.playState(loaderButtonState.hover);
            },
            onPointerOut: () => {
                this.playState(loaderButtonState.released);
            },
            // modelWatch: {
            //     btnStates: (btnStates: number[])=>{
            //         this.playState(btnStates[this.btn]);
            //     },
            // }
        }

    }

    private playState(state: number): void {
        switch (state) {
            case loaderButtonState.released:
                this.gotoAndStop('active');
                break;
            case loaderButtonState.hover:
                this.gotoAndStop('hover');
                break;
            case loaderButtonState.press:
                this.gotoAndStop('press');
                break;
        }
    }

    onInitialize(): void {
    }

}